import qs from "qs";
import React from "react";
import { useLocation } from "react-router-dom";
import { SvgSprite } from "./SvgSprite";

interface SortByLinkProps {
  sortBy: string;
  defaultAscending?: boolean;
}

export const SortByLink: React.FC<SortByLinkProps> = ({
  sortBy,
  children,
  defaultAscending = true,
}) => {
  const location = useLocation();
  const query = React.useMemo(() => {
    return qs.parse(location.search, { ignoreQueryPrefix: true });
  }, [location.search]);

  const isSorted = !!query.sortedBy;
  const isSortedByValue = isSorted && query.sortedBy === sortBy;

  const hasAscendingParam = query.ascending !== undefined;
  const isCurrentlyAscending = hasAscendingParam
    ? query.ascending === "true"
    : defaultAscending;

  const isAscending =
    isSortedByValue && hasAscendingParam
      ? !isCurrentlyAscending
      : defaultAscending;

  return (
    <a
      className="text-dark text-nowrap"
      href={`${location.pathname}?${qs.stringify({
        ...query,
        sortedBy: sortBy,
        ascending: isAscending,
      })}`}
    >
      {isSortedByValue && (
        <SvgSprite
          id={isCurrentlyAscending ? "icons:caret-up" : "icons:caret-down"}
          width={8}
          height={4}
          className="mr-1"
        />
      )}
      {children}
    </a>
  );
};
